import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import classNames from "classnames";


interface iSignUpModalOptions {
  double?: boolean;
  extraHeaderContent?: React.ReactNode;
  hideOverlay?: boolean;
  id?: string;
  onOpenAutoFocus?: (event: Event) => void;
  onOutsideCloseAction?: (event: Event) => void;
  modalClasses?: string;
}

export interface iSignUpModal {
  children: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  moreActions: React.ReactNode
  options?: iSignUpModalOptions;

}

const SignUpModal = ({
  children,
  open = false,
  setOpen,
  title,
  moreActions,
  options: { 
    double = false,
    extraHeaderContent,
    hideOverlay = false,
    id = undefined,
    onOpenAutoFocus = undefined,
    onOutsideCloseAction = undefined,
    modalClasses}
}: iSignUpModal) => (
  <Dialog.Root open={open} onOpenChange={setOpen}>
    <Dialog.Overlay className={classNames({
      "hnry-dialog-transition data-[state=open]:tw-animate-opacityShowFast data-[state=closed]:tw-animate-opacityHideFast": !hideOverlay,
    })}
    />
    {/* content should dictate size of the modal */}
    <Dialog.Content
      onOpenAutoFocus={onOpenAutoFocus}
      onInteractOutside={(e) => e.preventDefault()}
      onEscapeKeyDown={onOutsideCloseAction} // reusing same function on both actions so that clicking off modal and hitting esc have the same effect
      id={id}
      className={classNames(
        "hnry-dialog-full-panel md:!tw-h-fit data-[state=open]:animate-opacityShowFast data-[state=closed]:animate-opacityHideFast !tw-h-100svh",
        {
          [`${modalClasses}`]: modalClasses,
          "hnry-dialog-panel--double": double,
          "!shadow-[0_5px_25px_0_rgb(0,0,0,0.4)]": hideOverlay, // A stronger shadow is needed for the overlay to be visible
        },
      )}
    >
      <div className="hnry-dialog-full-panel-content tw-overflow-hidden">
        <div className="hnry-dialog-full-panel-header tw-mb-6">
          {extraHeaderContent}

          <Dialog.Title className="hnry-dialog-full-panel-header__title">
            {title}
          </Dialog.Title>
          { moreActions }
        </div>
        {children}

      </div>
    </Dialog.Content>
  </Dialog.Root>
)

export default SignUpModal;
